<template>
    <b-card no-body>
        <!-- Filtre alanı -->
        <div class="row px-1 pt-1 align-items-end">
            <div class="col-md-3 mb-1">
                <label class="form-label">Tarih Aralığı <span class="text-danger">*</span></label>
                <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Taşımacı Cari <span class="text-danger">*</span></label>
                <v-select-list v-model="selectedCaris" :options="cariList" label="CARI_ISIM" v-on:search="getCariList" placeholder="Taşımacı seçiniz" :loading="cariLoading" multiple :close-on-select="false"></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Bitiş Firma</label>
                <v-select-list v-model="selectedTargetCaris" :options="targetCariList" label="CARI_ISIM" v-on:search="getTargetCariList" placeholder="Tümü" :loading="targetCariLoading" multiple :close-on-select="false"></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Stok</label>
                <v-select-list v-model="stok" :options="stoks" label="Name" placeholder="Tümü" :loading="stokLoading"></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Şube</label>
                <v-select-list v-model="sube" :options="subeList" label="BranchName" placeholder="Tümü"></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Bölge</label>
                <v-select-list v-model="transferRegion" :options="transferRegionList" label="RegionName" placeholder="Tümü"></v-select-list>
            </div>
            <div class="col-auto mb-1">
                <v-executer :loading="loading" :action="getReport">Rapor Al</v-executer>
            </div>
            <div class="col-auto mb-1">
                <v-executer variant="success" :disabled="!hasData" :action="exportCsv">Excel'e Aktar</v-executer>
            </div>
        </div>

        <div v-if="report" class="px-1 pb-1">
            <!-- Fiyatı bulunamayan uyarısı -->
            <div v-if="report.FiyatiBulunmayanTasimaSayisi > 0" class="alert alert-warning py-50 px-1 mb-1">
                <strong>{{ report.FiyatiBulunmayanTasimaSayisi }}</strong> taşımanın sözleşmede eşleşen fiyatı bulunamadı (tutar 0 olarak hesaplandı). İlgili güzergâh/tarih için sözleşme fiyatı tanımlı olmayabilir.
            </div>

            <!-- Kapsam dışı kalan taşımalar: eksik tanım yüzünden rapora alınamayanlar -->
            <div v-if="report.KapsamDisiTasimaSayisi > 0" class="alert alert-danger py-50 px-1 mb-1">
                <strong>{{ report.KapsamDisiTasimaSayisi }}</strong> taşıma eksik tanım nedeniyle rapora alınamadı (bölge, araç tipi, stok ya da taşıma durumu eşleşmedi veya miktar 0). Rapor bu taşımaları içermiyor; ilgili tanımlar tamamlanmalıdır.
            </div>

            <!-- Hakedişten fiyatlananlar -->
            <div v-if="report.HakedistenFiyatlananTasimaSayisi > 0" class="alert alert-info py-50 px-1 mb-1">
                <strong>{{ report.HakedistenFiyatlananTasimaSayisi }}</strong> taşımanın tutarı, bağlı olduğu hakediş grubunda mutabık kalınan fiyattan alındı; kalanlar sözleşme fiyatıyla hesaplandı.
            </div>

            <!-- Genel toplam kartları -->
            <div class="row mb-1">
                <div class="col-6 col-md mb-1"><div class="stat-box"><div class="stat-label">Kayıt</div><div class="stat-val">{{ report.GenelToplam.KayitSayisi }}</div></div></div>
                <div class="col-6 col-md mb-1"><div class="stat-box"><div class="stat-label">Toplam Ağırlık (Ton)</div><div class="stat-val">{{ fmt(report.GenelToplam.Miktar) }}</div></div></div>
                <div class="col-6 col-md mb-1"><div class="stat-box"><div class="stat-label">Toplam Tutar (TL)</div><div class="stat-val">{{ fmt(report.GenelToplam.Tutar) }}</div></div></div>
                <div class="col-6 col-md mb-1"><div class="stat-box"><div class="stat-label">Toplam KDV (TL)</div><div class="stat-val">{{ fmt(report.GenelToplam.Kdv) }}</div></div></div>
                <div class="col-6 col-md mb-1"><div class="stat-box stat-primary"><div class="stat-label">Net Tutar (TL)</div><div class="stat-val">{{ fmt(report.GenelToplam.NetTutar) }}</div></div></div>
                <div class="col-6 col-md mb-1"><div class="stat-box"><div class="stat-label">Ort. Fiyat (TL/Ton)</div><div class="stat-val">{{ fmt(report.GenelToplam.OrtalamaFiyat) }}</div></div></div>
            </div>

            <!-- Özet tablolar -->
            <div class="row">
                <div class="col-md-4 mb-1">
                    <h6 class="mb-50">Taşımacıya Göre Özet</h6>
                    <table class="table table-sm table-bordered compact-report mb-0">
                        <thead><tr>
                            <th>Taşımacı</th><th class="num">Kayıt</th><th class="num">Ton</th><th class="num">Tutar</th><th class="num">Net</th><th class="num">Ort. Fiyat</th>
                        </tr></thead>
                        <tbody>
                            <tr v-for="(o,i) in report.TasiyiciOzet" :key="'t'+i">
                                <td>{{ o.Baslik }}</td>
                                <td class="num">{{ o.KayitSayisi }}</td>
                                <td class="num">{{ fmt(o.Miktar) }}</td>
                                <td class="num">{{ fmt(o.Tutar) }}</td>
                                <td class="num">{{ fmt(o.NetTutar) }}</td>
                                <td class="num">{{ fmt(o.OrtalamaFiyat) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-4 mb-1">
                    <h6 class="mb-50">Araç Tipine Göre Özet</h6>
                    <table class="table table-sm table-bordered compact-report mb-0">
                        <thead><tr>
                            <th>Araç Tipi</th><th class="num">Kayıt</th><th class="num">Ton</th><th class="num">Tutar</th><th class="num">Net</th><th class="num">Ort. Fiyat</th>
                        </tr></thead>
                        <tbody>
                            <tr v-for="(o,i) in report.AracTipiOzet" :key="'a'+i">
                                <td>{{ o.Baslik }}</td>
                                <td class="num">{{ o.KayitSayisi }}</td>
                                <td class="num">{{ fmt(o.Miktar) }}</td>
                                <td class="num">{{ fmt(o.Tutar) }}</td>
                                <td class="num">{{ fmt(o.NetTutar) }}</td>
                                <td class="num">{{ fmt(o.OrtalamaFiyat) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-4 mb-1">
                    <h6 class="mb-50">Destinasyona Göre Özet</h6>
                    <table class="table table-sm table-bordered compact-report mb-0">
                        <thead><tr>
                            <th>Destinasyon</th><th class="num">Kayıt</th><th class="num">Ton</th><th class="num">Tutar</th><th class="num">Net</th><th class="num">Ort. Fiyat</th>
                        </tr></thead>
                        <tbody>
                            <tr v-for="(o,i) in report.DestinasyonOzet" :key="'d'+i">
                                <td>{{ o.Baslik }}</td>
                                <td class="num">{{ o.KayitSayisi }}</td>
                                <td class="num">{{ fmt(o.Miktar) }}</td>
                                <td class="num">{{ fmt(o.Tutar) }}</td>
                                <td class="num">{{ fmt(o.NetTutar) }}</td>
                                <td class="num">{{ fmt(o.OrtalamaFiyat) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Detay tablo -->
            <h6 class="mb-50 mt-1">Taşıma Detayı ({{ report.Detaylar.length }} kayıt)</h6>
            <div class="table-responsive">
                <table class="table table-sm table-bordered compact-report mb-0">
                    <thead><tr>
                        <th>#</th><th>İrsaliye No</th><th>Tarih</th><th class="num">Hafta</th>
                        <th>Taşıyıcı</th>
                        <th>Destinasyon</th><th>Bitiş Firma</th><th>Araç Tipi</th><th>Stok</th><th>Durum</th>
                        <th>Fiyat Kaynağı</th>
                        <th class="num">Ağırlık (Ton)</th><th class="num">Birim Fiyat</th><th class="num">Tutar</th>
                        <th class="num">KDV %</th><th class="num">KDV</th><th class="num">Net Tutar</th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="d in report.Detaylar" :key="d.Sira" :class="{'row-noprice': !d.FiyatBulundu}">
                            <td>{{ d.Sira }}</td>
                            <td class="text-nowrap">{{ d.IrsaliyeNo }}</td>
                            <td class="text-nowrap">{{ d.Gun }}</td>
                            <td class="num">{{ d.Hafta }}</td>
                            <td>{{ d.Tasiyici }}</td>
                            <td>{{ d.Destinasyon }}</td>
                            <td>{{ d.BitisFirma }}</td>
                            <td>{{ d.AracTipi }}</td>
                            <td>{{ d.StokAdi }}</td>
                            <td>{{ d.TasimaDurumu }}</td>
                            <td class="text-nowrap">{{ fiyatKaynagi(d) }}</td>
                            <td class="num">{{ fmt(d.Miktar) }}</td>
                            <td class="num">{{ d.FiyatBulundu ? fmt(d.BirimFiyat) : '—' }}</td>
                            <td class="num">{{ fmt(d.Tutar) }}</td>
                            <td class="num">{{ fmt(d.KdvOrani) }}</td>
                            <td class="num">{{ fmt(d.Kdv) }}</td>
                            <td class="num">{{ fmt(d.NetTutar) }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="font-weight-bolder bg-light">
                            <td colspan="11" class="text-right">GENEL TOPLAM</td>
                            <td class="num">{{ fmt(report.GenelToplam.Miktar) }}</td>
                            <td class="num"></td>
                            <td class="num">{{ fmt(report.GenelToplam.Tutar) }}</td>
                            <td class="num"></td>
                            <td class="num">{{ fmt(report.GenelToplam.Kdv) }}</td>
                            <td class="num">{{ fmt(report.GenelToplam.NetTutar) }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { NetsisApi } from '@/api/netsis'
import { MaterialApi } from '@/api/material'
import { TransferRegionApi } from '@/api/transfer-region'
import moment from 'moment'
import Additional from '@/utilities/additional'

export default {
    components: { BCard },
    data() {
        return {
            queryData: {
                StartDate: moment().startOf('month').format('YYYY-MM-DD'),
                EndDate: moment().endOf('month').format('YYYY-MM-DD'),
                StockCode: null,
                BranchCode: null,
                RegionCode: null,
            },
            // Taşımacı ve bitiş firma çoklu seçilir; payload'da kod listelerine dönüştürülür.
            selectedCaris: [],
            selectedTargetCaris: [],
            cariList: [],
            targetCariList: [],
            stoks: [],
            subeList: [],
            transferRegionList: [],
            cariLoading: false,
            targetCariLoading: false,
            stokLoading: false,
            loading: false,
            report: null,
        }
    },
    mounted() {
        this.getStoks()
        this.getSubeList()
        this.getTransferRegions()
    },
    methods: {
        getReport() {
            if (!this.selectedCaris.length) {
                this.$result({ data: { Success: false, Message: 'Lütfen en az bir taşımacı cari seçiniz.' } })
                return
            }
            if (!this.queryData.StartDate || !this.queryData.EndDate) {
                this.$result({ data: { Success: false, Message: 'Lütfen tarih aralığı seçiniz.' } })
                return
            }
            this.loading = true
            NetsisApi.GetSeferMaliyetRaporu(this.payload).then(res => {
                if (!res.data.Success) {
                    this.$result(res)
                    this.report = null
                } else {
                    this.report = res.data.Data
                }
                this.loading = false
            }).catch(err => {
                console.log(err)
                this.loading = false
            })
        },
        getCariList(searchKey) {
            if (searchKey) {
                this.cariLoading = true
                NetsisApi.CariList(searchKey).then(res => {
                    this.cariList = res.data.Data
                    this.cariLoading = false
                }).catch(() => { this.cariLoading = false })
            }
        },
        getTargetCariList(searchKey) {
            if (searchKey) {
                this.targetCariLoading = true
                NetsisApi.CariList(searchKey).then(res => {
                    this.targetCariList = res.data.Data
                    this.targetCariLoading = false
                }).catch(() => { this.targetCariLoading = false })
            }
        },
        getStoks() {
            this.stokLoading = true
            MaterialApi.List().then(res => {
                this.stoks = res.data.Data
                this.stokLoading = false
            }).catch(() => { this.stokLoading = false })
        },
        getSubeList() {
            NetsisApi.GetSubeList().then(res => {
                this.subeList = res.data.Data
            }).catch(err => console.log(err))
        },
        getTransferRegions() {
            TransferRegionApi.List().then(res => {
                this.transferRegionList = res.data.Data
            }).catch(err => console.log(err))
        },
        // Hakedişten fiyatlanan satırlarda grup referansı da gösterilir; kullanıcı tutarı
        // hangi mutabakattan geldiğine bakarak doğrulayabilsin.
        fiyatKaynagi(d) {
            if (d.FiyatKaynagi === 'Hakediş') {
                return d.HakedisReferansNo ? `Hakediş (${d.HakedisReferansNo})` : 'Hakediş'
            }
            if (d.FiyatKaynagi === 'Sözleşme') return 'Sözleşme'
            return '—'
        },
        fmt(value) {
            if (value === null || value === undefined || value === '') return ''
            const n = Number(value)
            if (isNaN(n)) return value
            return n.toLocaleString('tr-TR', { maximumFractionDigits: 2 })
        },
        exportCsv() {
            if (!this.hasData) return
            const headers = ['Sıra', 'İrsaliye No', 'Tarih', 'Hafta', 'Taşıyıcı', 'Taşıyıcı Cari Kodu', 'Destinasyon', 'Bitiş Firma', 'Başlangıç Firma', 'Araç Tipi', 'Stok Kodu', 'Stok Adı', 'Taşıma Durumu', 'Ağırlık (Ton)', 'Birim Fiyat (TL/Ton)', 'Tutar', 'KDV Oranı (%)', 'KDV', 'Net Tutar', 'Fiyat Bulundu', 'Fiyat Kaynağı', 'Hakediş Referans No']
            const esc = v => {
                if (v === null || v === undefined) return ''
                const s = String(v).replace(/"/g, '""')
                return /[";\n]/.test(s) ? `"${s}"` : s
            }
            const rows = this.report.Detaylar.map(d => [
                d.Sira, d.IrsaliyeNo, d.Gun, d.Hafta, d.Tasiyici, d.TasiyiciCariKodu, d.Destinasyon, d.BitisFirma, d.BaslangicFirma,
                d.AracTipi, d.StokKodu, d.StokAdi, d.TasimaDurumu, d.Miktar, d.BirimFiyat, d.Tutar,
                d.KdvOrani, d.Kdv, d.NetTutar, d.FiyatBulundu ? 'Evet' : 'Hayır',
                d.FiyatKaynagi, d.HakedisReferansNo,
            ].map(esc).join(';'))
            const csv = '﻿' + [headers.join(';'), ...rows].join('\r\n')
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
            const name = `Sefer Maliyet Raporu - ${this.cariLabel} - ${this.queryData.StartDate} - ${this.queryData.EndDate}.csv`
            Additional.DownloadFile(blob, name)
        },
    },
    computed: {
        hasData() {
            return !!(this.report && this.report.Detaylar && this.report.Detaylar.length)
        },
        payload() {
            return {
                ...this.queryData,
                CariCodes: this.selectedCaris.map(c => c.CARI_KOD),
                TargetCariCodes: this.selectedTargetCaris.map(c => c.CARI_KOD),
            }
        },
        // Dosya adında kullanılır: tek taşımacıda adı, çokluda sayısı yazılır.
        cariLabel() {
            if (this.selectedCaris.length === 1) return this.selectedCaris[0].CARI_ISIM
            return `${this.selectedCaris.length} taşımacı`
        },
        date: {
            get() { return [this.queryData.StartDate, this.queryData.EndDate].filter(d => d != null) },
            set(val) {
                this.queryData.StartDate = val[0] || null
                this.queryData.EndDate = val[1] || null
            },
        },
        stok: {
            get() { return this.stoks.find(s => s.Code == this.queryData.StockCode) },
            set(value) { this.queryData.StockCode = value?.Code || null },
        },
        sube: {
            get() { return this.subeList.find(s => s.BranchCode == this.queryData.BranchCode) },
            set(value) { this.queryData.BranchCode = value?.BranchCode || null },
        },
        transferRegion: {
            get() { return this.transferRegionList.find(s => s.RegionCode == this.queryData.RegionCode) },
            set(value) { this.queryData.RegionCode = value?.RegionCode || null },
        },
    },
}
</script>

<style scoped>
.compact-report {
    font-size: 0.72rem;
    width: 100%;
}
.compact-report th,
.compact-report td {
    padding: 0.2rem 0.35rem;
    vertical-align: middle;
    white-space: normal;
    word-break: break-word;
}
.compact-report th.num,
.compact-report td.num {
    text-align: right;
    white-space: nowrap;
}
.row-noprice {
    background-color: rgba(255, 159, 67, 0.12);
}
.stat-box {
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.4rem;
    padding: 0.6rem 0.8rem;
    height: 100%;
}
.stat-box.stat-primary {
    background: rgba(115, 103, 240, 0.08);
    border-color: rgba(115, 103, 240, 0.3);
}
.stat-label {
    font-size: 0.7rem;
    color: #6e6b7b;
}
.stat-val {
    font-size: 1.1rem;
    font-weight: 600;
}
</style>
